export const BULK_CREATE_BATCH_SIZE = 100;
